import React from 'react';
import StarRatingDisplay from './StarRatingDisplay';
import './ReviewsStatsCards.css';

const formatAverage = (value) => value.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });

const ReviewsStatsCards = ({ stats }) => {
  const { total, average, distribution, activeCount, activePercentage } = stats;
  const maxDistribution = Math.max(1, ...Object.values(distribution));

  return (
    <div className="reviews-stats-grid">
      <div className="cp-card reviews-stat-card">
        <p className="reviews-stat-card__label">Avaliação média</p>
        <div className="reviews-stat-card__value-row">
          <span className="reviews-stat-card__value">{formatAverage(average)}</span>
          <StarRatingDisplay rating={average} />
        </div>
        <p className="reviews-stat-card__subtitle">Baseado em {total} avaliações</p>
      </div>

      <div className="cp-card reviews-stat-card">
        <p className="reviews-stat-card__label">Avaliações</p>
        <span className="reviews-stat-card__value">{total}</span>
        <p className="reviews-stat-card__subtitle">avaliações cadastradas</p>
      </div>

      <div className="cp-card reviews-stat-card">
        <p className="reviews-stat-card__label">Distribuição</p>
        <div className="reviews-distribution">
          {[5, 4, 3, 2, 1].map((star) => (
            <div className="reviews-distribution__row" key={star}>
              <span className="reviews-distribution__star">{star} ★</span>
              <div className="reviews-distribution__bar-track">
                <div
                  className="reviews-distribution__bar-fill"
                  style={{ width: `${(distribution[star] / maxDistribution) * 100}%` }}
                />
              </div>
              <span className="reviews-distribution__count">{distribution[star]}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="cp-card reviews-stat-card">
        <p className="reviews-stat-card__label">Avaliações ativas</p>
        <span className="reviews-stat-card__value">{activeCount}</span>
        <p className="reviews-stat-card__subtitle">{activePercentage}% do total</p>
      </div>
    </div>
  );
};

export default ReviewsStatsCards;
